import React from 'react'
import ReactModal from 'react-modal'
import { ModalGlobalStyle } from './styled'
import { ReactComponent as CloseSvgIcon } from './close.svg'
import { CSS_CLASS } from './constants'

interface Props {
  isOpen: boolean
  shouldCloseOnEsc?: boolean
  shouldCloseOnOverlayClick?: boolean
  handleCloseModal?: () => void
  onRequestClose?: () => void
}

export const Modal: React.FC<Props> = ({
  children,
  handleCloseModal,
  onRequestClose,
  shouldCloseOnEsc = true,
  shouldCloseOnOverlayClick = true,
  isOpen
}) => {
  const handleAfterOpen = () => {
    document.documentElement.classList.add(CSS_CLASS.REMOVE_SCROLL)
  }

  const handleAfterClose = () => {
    document.documentElement.classList.remove(CSS_CLASS.REMOVE_SCROLL)
  }

  const className = `${CSS_CLASS.MODAL}`

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose ?? handleCloseModal}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      shouldCloseOnEsc={shouldCloseOnEsc}
      ariaHideApp={false}
      className={className}
      overlayClassName={CSS_CLASS.OVERLAY}
      onAfterOpen={handleAfterOpen}
      onAfterClose={handleAfterClose}
    >
      {handleCloseModal && (
        <button
          onClick={handleCloseModal}
          className={CSS_CLASS.CLOSE}
        >
          <CloseSvgIcon />
        </button>
      )}

      {children}
    </ReactModal>
  )
}

export {
  ModalGlobalStyle
}
